import PageHeader from 'components/common/PageHeader';
import { useCallback, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getBranchOfficesByUserId } from 'redux/branchOfficeSlice';
import {
  getAllProjects,
  getAllProps,
  getPendingProjects,
  getPendingProps,
  getProjectsByDay,
  getPropsByDay,
  getPublishedProjects,
  getPublishedProps,
  getUnreadProjects,
  getUnreadProps
} from 'redux/infoSlice';
import {
  getRealEstateByUserId,
  getRealEstateData,
  getRealEstateList,
  getRealEstateProjectStats,
  getRealEstatePropStats,
  emptyAllRealEstateData
} from 'redux/realEstateSlice';
import GreetingCard from './components/cards/GreetingCard';
import StatisticsCards from './components/cards/StatisticsCards';
import ResumeCard from './components/cards/ResumeCard';
import { SingleREFilter } from '../misEstadisticas/SingleREFilter';
import { BranchOfficeFilter } from '../../gestionarPropiedades/tables/propertiesTable/components/filters/BranchOfficeFilter';
import { FilterByDay } from './components/cards/FilterByDay';
import { filterTypes } from '../filterHelpers';

const Resumen = () => {
  // * States
  const dispatch = useDispatch();

  const { propsByDay, projectsByDay } = useSelector(state => state.info);

  const { notifications } = useSelector(state => state.notifications);
  const { currentUser: userLogged } = useSelector(state => state.login);
  const {
    realEstateList,
    realEstatePropStats,
    realEstateProjStats,
    realEstate,
    branchOfficesArray
  } = useSelector(state => state.realEstate);

  const { branchOffices } = useSelector(state => state.branchOffice);
  const [mainFilters, setMainFilters] = useState();

  let currentMonth = new Date().toLocaleString('default', { month: 'long' });
  currentMonth = currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1);

  // * Methods
  const GetResume = async () => {
    await dispatch(getPropsByDay([mainFilters.branchOffices]));
    await dispatch(getProjectsByDay([mainFilters.branchOffices]));
  };

  // * Life Cycle
  const getInfo = useCallback((realEstateId, branchOfficesId) => {
    dispatch(getAllProps(realEstateId, branchOfficesId));
    dispatch(getPendingProps(realEstateId, branchOfficesId));
    dispatch(getPublishedProps(realEstateId, branchOfficesId));
    dispatch(getUnreadProps(realEstateId, branchOfficesId));

    dispatch(getAllProjects(realEstateId, branchOfficesId));
    dispatch(getPendingProjects(realEstateId, branchOfficesId));
    dispatch(getPublishedProjects(realEstateId, branchOfficesId));
    dispatch(getUnreadProjects(realEstateId, branchOfficesId));
  }, []);

  useEffect(() => {
    // Seteo el estado de real estate y oficinas a null
    dispatch(emptyAllRealEstateData());
  }, []);

  // Obtengo la RE y sus BO del usuario, o el listado de RE si es cucicba
  useEffect(() => {
    if (userLogged) {
      if (userLogged.typeOfUser === 'cucicba') {
        dispatch(getRealEstateList());
        // Obtengo la info de toda la app
        getInfo();
      } else {
        dispatch(getRealEstateByUserId(userLogged.id));
        dispatch(getBranchOfficesByUserId(userLogged.id));
      }
    }
  }, [userLogged]);

  // Seteo filtros iniciales
  useEffect(() => {
    if (realEstateList) {
      setMainFilters({
        realEstateId: 0,
        branchOffices: [],
        filterType: 0,
        desde: new Date(),
        hasta: new Date()
      });
    } else {
      if (branchOffices?.length) {
        setMainFilters({
          realEstateId: realEstate.id,
          branchOffices: [branchOffices[0]?.id],
          filterType: 0,
          desde: new Date(),
          hasta: new Date()
        });
      }
    }
  }, [realEstate, branchOffices, realEstateList]);

  useEffect(() => {
    if (mainFilters?.branchOffices?.length) {
      // Info charts
      GetResume();

      // Info col derecha
      if (realEstateList) {
        getInfo(
          undefined,
          branchOfficesArray.map(branchOffice => branchOffice.id)
        );
      } else {
        if (userLogged?.typeOfUser === 'admin' && realEstate?.id) {
          getInfo(realEstate.id);
        } else if (
          userLogged?.typeOfUser === 'collab' &&
          branchOffices?.length
        ) {
          getInfo(
            undefined,
            branchOffices.map(branchOffice => branchOffice.id)
          );
        }
      }
    }
  }, [mainFilters]);

  // Solo para user type cucicba
  useEffect(() => {
    if (realEstateList && mainFilters?.realEstateId) {
      setMainFilters({ ...mainFilters, branchOffices: [] });
      dispatch(getRealEstateData(mainFilters.realEstateId));
    }
  }, [mainFilters?.realEstateId]);

  // * Life Cycle
  useEffect(() => {
    realEstate?.id && dispatch(getRealEstatePropStats(realEstate.id));
    realEstate.id && dispatch(getRealEstateProjectStats(realEstate.id));
    console.log(realEstate);
    console.log(realEstateProjStats);
  }, [realEstate]);

  return (
    <>
      <Row className="g-3 mb-3">
        <Col xs={12}>
          <PageHeader
            title="Resumen"
            description={`Resumen de la Inmobiliaria en el mes de ${currentMonth}.`}
            className="bg-white"
          />
        </Col>

        {userLogged && (
          <>
            <Col xs={12} xl={8} xxl={9}>
              <Row className="g-3">
                {/* Card con notificaciones */}
                <Col xs={12}>
                  <GreetingCard
                    notifications={notifications || []}
                    user={userLogged}
                  />
                </Col>

                {/* Filtros  */}
                <Col xs={12}>
                  <Card className="bg-white">
                    <Card.Header className="border-bottom">
                      <Card.Title>Gráficos mensuales</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col>
                          {mainFilters && (
                            <>
                              <div className="mb-3">
                                {realEstateList && (
                                  <SingleREFilter
                                    setMainFilters={setMainFilters}
                                    mainFilters={mainFilters}
                                    options={[
                                      {
                                        id: 0,
                                        name: 'Seleccionar inmobiliaria'
                                      },
                                      ...realEstateList
                                    ]}
                                  />
                                )}
                                {realEstate && <h5>{realEstate.name}</h5>}
                              </div>

                              {(!!branchOffices?.length ||
                                !!branchOfficesArray?.length) && (
                                <div className="mb-3">
                                  <BranchOfficeFilter
                                    setFiltersAndSort={setMainFilters}
                                    filtersAndSort={mainFilters}
                                    branchOffices={
                                      realEstateList
                                        ? branchOfficesArray
                                        : branchOffices
                                    }
                                    showTitle={false}
                                  />
                                </div>
                              )}
                              <FilterByDay
                                setAnualFilters={setMainFilters}
                                anualFilters={mainFilters}
                                options={filterTypes}
                                isDisabled={!mainFilters.branchOffices.length}
                              />
                            </>
                          )}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Gráfico de propiedades */}
                {propsByDay && !!mainFilters?.branchOffices?.length && (
                  <Col xs={12}>
                    <ResumeCard
                      data={
                        mainFilters?.branchOffices?.length
                          ? propsByDay[0]?.results?.[
                              filterTypes[mainFilters?.filterType]?.name
                            ]
                          : []
                      }
                      title="Propiedades"
                    />
                  </Col>
                )}

                {/* Gráfico de emprendimientos */}
                {projectsByDay && !!mainFilters?.branchOffices?.length && (
                  <Col xs={12}>
                    <ResumeCard
                      data={
                        mainFilters?.branchOffices?.length
                          ? projectsByDay[0]?.results?.[
                              filterTypes[mainFilters?.filterType]?.name
                            ]
                          : []
                      }
                      title="Emprendimientos"
                    />
                  </Col>
                )}
              </Row>
            </Col>

            <Col xs={12} xl={4} xxl={3}>
              <StatisticsCards
                realEstateProjStats={realEstateProjStats}
                realEstatePropStats={realEstatePropStats}
              />
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default Resumen;
